import { IncomeTypeEnum } from "@lending/types";

export const EMPLOYMENT_TYPES: { code: IncomeTypeEnum; name: string }[] = [
  { code: "employed", name: "Employed" },
  { code: "self_employed", name: "Self-employed" },
  { code: "retirement", name: "Retired" },
  { code: "other", name: "Other" },
];
